import type { ExperimentConfig } from '../@types'

// DEV-34793 — BR pricing unification. Brazil-only A/B (variant B = unified renewal ladder).
// BR-scoping is enforced by the ABsmartly audience (country = BR); every targeted funnel
// swaps to the same unified BR ladder via the shared transform below.
// Debug (per funnel): /result_complete?safe&mock-data&utm_source=FB&country=BR&area=<appArea>&exp=web_br_pricing_unification~1
const paywall = {
	experiment: () =>
		import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_br_pricing_unification'),
}

const config: ExperimentConfig[] = [
	{
		// Group 1 — ML rolled out (control BR 17/39/69 → 99/99/179)
		female: { paywall },
		'activity-male-walking': { paywall },
		'activity-female-tai-chi-walking-v2-al': { paywall },
		'activity-male-tai-chi-walking-al': { paywall },
		'activity-male-chair-tai-chi': { paywall },
		'activity-male-tai-chi-yoga-pr': { paywall },

		// Group 2 — ML not rolled out (control BR 38.99/85.99/146.99 → 219/219/379)
		'activity-female-walking': { paywall },

		// Group 3 — untested (control BR 17/39/79 → 179/179/319, 1m/3m cadence)
		'activity-female-tai-chi-walking-v2': { paywall },
		'activity-female-tai-chi-walking-pr': { paywall },
	},
]

export default config
